import SlideAPI from '@/api/slide'
import AudienceAPI from '@/api/audience'
import ReactionAPI from '@/api/reaction'
import SlideOptionApi from '@/api/slide-option'

const initResources = () => {
  SlideAPI.initResource()
  AudienceAPI.initResource()
  ReactionAPI.initResource()
  SlideOptionApi.initResource()
}

export default {
  initResources,
}
